import { Career } from "./Career/Career.js";
import { Contact } from "./Contact/Contact.js";
import { Header } from "./Header/Header.js";
import { Skills } from "./Skills/Skills.js";
import { AboutMe } from "./AboutMe/AboutMe";
import { Projects } from "./Projects/Projects.js";

export {
  Career,
  Contact,
  Header,
  Skills,
  AboutMe,
  Projects,
};
